import { Component } from '@angular/core';
import { soundpostAgreementEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';
import {  } from "@memberjunction/ng-entity-viewer"

@RegisterClass(BaseFormComponent, 'Agreements') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-soundpostagreement-form',
    templateUrl: './soundpostagreement.form.component.html'
})
export class soundpostAgreementFormComponent extends BaseFormComponent {
    public record!: soundpostAgreementEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true },
            { sectionKey: 'agreementLines', sectionName: 'Agreement Lines', isExpanded: false }
        ]);
    }
}

